import {
  AutoComplete,
  Avatar,
  Button,
  Form,
  Input,
  Select,
  Spin,
  Tag,
  Checkbox,
  Drawer,
  Radio,
  Alert,
  Modal,
} from "antd";
import axios from "axios";
import { debounce } from "lodash";
import React, {
  ReactElement,
  useCallback,
  useEffect,
  useRef,
  useState,
} from "react";
import { authenticateToken } from "../../utils/auth";
import {
  getImgUrl,
  jcTypeArray,
  getUpdatedUrl,
  getUrlQueries,
  checkStatesAndPushToHistory,
} from "../../utils/index";
import Loading from "../common/Loader";
import PaginationTwo from "../common/PaginationTwo";
import TopHeading, { ProductCreateProps } from "./TopHeading";
import { useHistory, useLocation } from "react-router";
import Empty from "../common/Empty";
import { responseNotification } from "../../utils/notify";
import {
  BarcodeOutlined,
  CopyOutlined,
  EditOutlined,
  SwapOutlined,
} from "@ant-design/icons";
import usePrevious from "../../hooks/PreviousState";
const { Option } = Select;

const GlobalProductList = (): ReactElement => {
  const queryParams = new URLSearchParams(window.location.search);
  // --------------------------------
  const [checkedList, setCheckedList] = React.useState([]);
  const [indeterminate, setIndeterminate] = React.useState(true);
  const [checkAll, setCheckAll] = React.useState(false);
  const [activeClone, setActiveClone] = useState(undefined);
  const [changeCat, setChangeCat] = useState(undefined);
  const [targetCategoryId, setTargetCategoryId] = useState<any>();
  // --------------------------------
  const [limit, setLimit] = useState(50);
  const [type, setType] = useState(
    queryParams.get("type") ? queryParams.get("type") : "JC_MART"
  );
  const [selectedProductBarcode, setSelectedProductBarcode] = useState([]);
  const [visible, setVisible] = useState(undefined);
  const [loading, setLoading] = useState(false);
  const [productData, setProductData] = useState<any>({
    loading: false,
    item: [],
  });
  const [status, setStatus] = useState("");
  const [key, setKey] = useState(queryParams.get("key"));
  const [barCode, setBarCode] = useState(queryParams.get("barCode"));
  const [isDeleted, setIsDeleted] = useState("");

  const [productBarcodeOptions, setProductBarcodeOptions] = useState<any>({
    list: [],
    loading: false,
  });
  const [productOptions, setProductOptions] = useState<any>({
    list: [],
    loading: false,
  });
  const [parentCatOptions, setParentCatOptions] = useState<any>({
    list: [],
    loading: false,
  });
  const [categoriesOptions, setCategoriesOptions] = useState<any>({
    list: [],
    loading: false,
  });

  const [parentCategoryId, setParentCategoryId] = useState(
    queryParams.get("parentCategoryId")
  );

  const [drawerParentCatId, setDrawerParentCatId] = useState<any>();
  const [childCategoryId, setChildCategoryId] = useState(
    queryParams.get("childCategoryId")
  );
  const [brandsOptions, setBrandsOptions] = useState<any>({
    list: [],
    loading: false,
  });
  const [merchantId, setMerchantId] = useState<any>();
  const [brandId, setBrandId] = useState<any>();
  const [shopId, setShopId] = useState<any>();
  const [supplierId, setSupplierId] = useState();
  const [merchantOptions, setMerchantOptions] = useState({
    loading: false,
    list: [],
  });
  const [shopsOptions, setShopsOptions] = useState<any>({
    list: [],
    loading: false,
  });
  const [suppliersOptions, setSuppliersOptions] = useState<any>({
    list: [],
    loading: false,
  });

  const router = useLocation();
  const history = useHistory();

  const [form] = Form.useForm();

  const page = getUrlQueries(history.location.search).page || 0;
  // =================== for storing filtering history
  // useEffect(() => {
  //   const existedParams = getUrlQueries(router.search);
  //   setType(existedParams?.type || "JC_MART");
  //   setParentCatId(existedParams?.parentCatId);
  //   setCategoryId(existedParams?.categoryId);
  //   setBarCode(existedParams?.barCode);
  //   setKey(existedParams?.key);
  // }, []);

  // useEffect(() => {
  //   form.resetFields();
  //   if (
  //     isUrlWillChanged(
  //       ["type", "categoryId", "parentCatId", "barCode", "key"],
  //       [type, categoryId, parentCatId, barCode, key]
  //     )
  //   ) {
  //     history.push(
  //       getUpdatesUrl(
  //         ["type", "categoryId", "parentCatId", "barCode", "key"],
  //         [type, categoryId, parentCatId, barCode, key]
  //       )
  //     );
  //   }
  // }, [type, parentCatId, categoryId, barCode, key, history, form]);

  const prevType = usePrevious(type);
  const prevBarCode = usePrevious(barCode);
  const prevKey = usePrevious(key);
  const prevParentCategoryId = usePrevious(parentCategoryId);
  const prevChildCategoryId = usePrevious(childCategoryId);

  window.onbeforeunload = () => {
    saveCurrentStatesInLocalStorage();
  };

  // ======================================================

  const fetchProducts = useCallback(async () => {
    if (type) {
      let shouldResetPage = false;
      try {
        setProductData({ loading: true, item: [] });
        if (localStorage.getItem("rememberGlobalProductList") != null) {
          checkLocalStorageAndSetParams();
          localStorage.removeItem("rememberGlobalProductList");
        } else {
          shouldResetPage = checkStatesAndPushToHistory(
            [
              prevType,
              prevBarCode,
              prevKey,
              prevParentCategoryId,
              prevChildCategoryId,
            ],
            [type, barCode, key, parentCategoryId, childCategoryId],
            ["type", "barCode", "key", "parentCategoryId", "childCategoryId"],
            history
          );
        }

        const url =
          `${process.env.REACT_APP_CATALOG_READER_API}/global-product?` +
          `page=${shouldResetPage ? 0 : page || 0}` +
          `&limit=${limit || 16}` +
          (type ? `&type=${type}` : ``) +
          (key ? `&key=${key}` : ``) +
          (barCode ? `&barCode=${barCode}` : ``) +
          (childCategoryId ? `&childCategoryId=${childCategoryId}` : ``) +
          (parentCategoryId ? `&categoryId=${parentCategoryId}` : ``);

        // setPrevRefs();

        await fetch(url, {
          headers: {
            Authorization: `Bearer ${authenticateToken()}`,
            "Content-Type": "application/json",
          },
        })
          .then((res) => res.json())
          .then((data) => {
            setProductData({ loading: false, item: data });
            setCheckedList(data.products.map((product) => product?.barCode));
          });
      } catch (error) {
        setProductData({ loading: true, item: [] });
        console.log(error, "error");
      }
    }
  }, [limit, page, parentCategoryId, childCategoryId, key, barCode, type]);

  const getProductByBarcodeOptions = useCallback(
    async (bCode) => {
      setProductBarcodeOptions({ loading: false, list: [] });

      setProductBarcodeOptions({ loading: true, list: [] });
      const encodedUri = `${process.env.REACT_APP_CATALOG_READER_API}`;

      const res = await axios.get(
        `${encodedUri}/global-product?page=0&limit=20` +
          (bCode ? `&barCode=${bCode}` : ``) +
          (key ? `&key=${key}` : ``) +
          (childCategoryId
            ? `&categoryId=${childCategoryId}`
            : parentCategoryId
            ? `&categoryId=${parentCategoryId}`
            : ``) +
          (type ? `&type=${type}` : ``) +
          (isDeleted !== "" ? `&isDeleted=${isDeleted}` : ``) +
          (status ? `&status=${status}` : ``),
        {
          headers: {
            Authorization: `Bearer ${authenticateToken()}`,
          },
        }
      );
      setProductBarcodeOptions({
        loading: false,
        list: res?.data?.products?.map(
          (product: { name: any; barCode: any }) => {
            return {
              value: product?.barCode,
              label: product?.name,
            };
          }
        ),
      });
    },
    [key, childCategoryId, parentCategoryId, type, isDeleted, status]
  );

  const getProductOptions = useCallback(
    async (val) => {
      setProductOptions({ loading: false, list: [] });

      setProductOptions({ loading: true, list: [] });
      const encodedUri = `${process.env.REACT_APP_CATALOG_READER_API}`;

      const res = await axios.get(
        `${encodedUri}/global-product?page=0&limit=20` +
          (val ? `&key=${val}` : ``) +
          (barCode ? `&barCode=${barCode}` : ``) +
          (type ? `&type=${type}` : ``) +
          (childCategoryId
            ? `&categoryId=${childCategoryId}`
            : parentCategoryId
            ? `&categoryId=${parentCategoryId}`
            : ``) +
          (isDeleted !== "" ? `&isDeleted=${isDeleted}` : ``) +
          (status ? `&status=${status}` : ``),
        {
          headers: {
            Authorization: `Bearer ${authenticateToken()}`,
          },
        }
      );
      setProductOptions({
        loading: false,
        list: res?.data?.products?.map((product: { name: any }) => {
          return {
            value: product?.name,
            label: product?.name,
          };
        }),
      });
    },
    [barCode, type, childCategoryId, parentCategoryId, isDeleted, status]
  );

  const getParentCatOptions = useCallback(
    async (val?: string) => {
      setParentCatOptions({ loading: true, list: [] });
      const res = await axios.get(
        `${process.env.REACT_APP_CATALOG_READER_API}/admin/category/parent-by-type?page=0&limit=20` +
          (val ? `&key=${val}` : ``) +
          (type ? `&type=${type}` : ``),
        {
          headers: {
            Authorization: `Bearer ${authenticateToken()}`,
          },
        }
      );

      setParentCatOptions({
        loading: false,
        list: res?.data?.categories?.map((category) => {
          return {
            value: category?.id,
            label: category?.title,
          };
        }),
      });
    },
    [type]
  );

  const getCategoriesOptions = useCallback(
    async (val?: string) => {
      if (parentCategoryId) {
        setCategoriesOptions({ loading: true, list: [] });
        const res = await axios.get(
          `${process.env.REACT_APP_CATALOG_READER_API}/admin/category/child-category-by-parent?page=0&limit=20` +
            (val ? `&key=${val}` : ``) +
            (drawerParentCatId
              ? `&categoryId=${drawerParentCatId}`
              : parentCategoryId
              ? `&categoryId=${parentCategoryId}`
              : ``) +
            (type ? `&type=${type}` : ``),
          {
            headers: {
              Authorization: `Bearer ${authenticateToken()}`,
            },
          }
        );
        setCategoriesOptions({
          loading: false,
          list: res?.data?.categories?.map((category) => {
            return {
              value: category?.id,
              label: category?.title,
            };
          }),
        });
      } else {
        setCategoriesOptions({ loading: true, list: [] });
        const res = await axios.get(
          `${process.env.REACT_APP_CATALOG_READER_API}/admin/category/child-by-type?page=0&limit=20` +
            (val ? `&key=${val}` : ``) +
            (drawerParentCatId ? `&parentCategory=${drawerParentCatId}` : ``) +
            (type ? `&type=${type}` : ``),
          {
            headers: {
              Authorization: `Bearer ${authenticateToken()}`,
            },
          }
        );
        setCategoriesOptions({
          loading: false,
          list: res?.data?.categories?.map((category) => {
            return {
              value: category?.id,
              label: category?.title,
            };
          }),
        });
      }
    },
    [type, parentCategoryId, drawerParentCatId]
  );

  const getBrandsOptions = useCallback(
    async (val?: string) => {
      setBrandsOptions({ loading: true, list: [] });

      const res = await axios.get(
        `${process.env.REACT_APP_CATALOG_READER_API}/brand/search?page=0&limit=20` +
          (type ? `&type=${type}` : ``) +
          (val ? `&key=${val}` : ``),

        {
          headers: {
            Authorization: `Bearer ${authenticateToken()}`,
          },
        }
      );

      setBrandsOptions({
        loading: false,
        list: res?.data?.brands?.map((brand) => {
          return {
            id: brand?.id,
            name: brand?.name,
          };
        }),
      });
    },
    [type]
  );

  const getMerchantsOptions = useCallback(
    async (key?: string) => {
      setMerchantOptions({ loading: true, list: [] });
      const encodedUri = `${process.env.REACT_APP_CATALOG_READER_API}`;
      const res = await axios.get(
        `${encodedUri}/merchant/all?page=0&limit=20` +
          (type ? `&type=${type}` : ``) +
          (key ? `&name=${key}` : ``),
        {
          headers: {
            Authorization: `Bearer ${authenticateToken()}`,
          },
        }
      );

      setMerchantOptions({
        loading: false,
        list: res.data?.merchants?.map((merchant) => ({
          label: merchant.name,
          value: merchant.id,
        })),
      });
    },
    [type]
  );

  const getShopsOptions = useCallback(
    async (val?: string) => {
      setShopsOptions({ loading: true, list: [] });

      const res = await axios.get(
        `${process.env.REACT_APP_CATALOG_READER_API}/admin/shop${
          merchantId ? "/by-merchant" : ``
        }?page=0&limit=20` +
          (merchantId ? `&merchantId=${merchantId}` : ``) +
          (val ? `&key=${val}` : ``) +
          (type ? `&type=${type}` : ``),
        {
          headers: {
            Authorization: `Bearer ${authenticateToken()}`,
          },
        }
      );
      setShopsOptions({
        loading: false,
        list: res?.data?.shops?.map((shop) => {
          return {
            value: shop?.id,
            label: shop?.name,
          };
        }),
      });
    },
    [type, merchantId]
  );

  const getSupplierOptions = useCallback(
    async (val?: string) => {
      setSuppliersOptions({ loading: true, list: [] });

      const res = await axios.get(
        `${process.env.REACT_APP_CATALOG_READER_API}/admin/supplier/by-shop` +
          (shopId ? `?shopId=${shopId}` : ``) +
          (val ? `&key=${val}` : ``) +
          (page ? `&page=${page}` : ``) +
          (limit ? `&limit=${limit}` : ``) +
          (type ? `&type=${type}` : ``),
        {
          headers: {
            Authorization: `Bearer ${authenticateToken()}`,
          },
        }
      );
      setSuppliersOptions({
        loading: false,
        list: res?.data?.suppliers?.map((supplier) => {
          return {
            value: supplier?.id,
            label: supplier?.name,
          };
        }),
      });
    },
    [shopId, page, limit, type]
  );

  //
  const onSubmit = async (data: any) => {
    setLoading(true);
    if (activeClone) {
      const readyData = data && {
        barCodes: selectedProductBarcode,
        shopIds: [shopId],
        // shopIds: selectedShopId,
        supplierId: supplierId,
      };

      await fetch(
        `${process.env.REACT_APP_CATALOG_WRITER_API}/product/add-from-global-product`,
        {
          method: "POST",
          headers: {
            Authorization: `Bearer ${authenticateToken()}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify(readyData),
        }
      )
        .then((res) => res.json())
        .then((res) => {
          setLoading(false);

          if (res.statusCode === 200) {
            responseNotification(
              "Product Cloned Successfully in Selected Shop(s)",
              "success"
            );
            // getShopsOptions();
            info({
              alreadyExists: res?.alreadyExists,
              newAdded: res?.newAdded,
              list: res?.alreadyExistsProductName,
            });

            setVisible(!visible);
            form.resetFields();
          } else if (res.status === 500) {
            responseNotification("Internal server error", "error");
          } else {
            responseNotification(res.message || "something wrong", "warning");
          }
        })
        .catch((err) => {
          setLoading(false);
          responseNotification(`${"Internal server error"} ${err}`, "error");
          console.error("err", err);
        });
    } else {
      const readyData = data && {
        barCodes: data.barCodes || selectedProductBarcode,
        categoryId: targetCategoryId,
      };

      await fetch(
        `${process.env.REACT_APP_CATALOG_WRITER_API}/global-product/category-update`,
        {
          method: "PUT",
          headers: {
            Authorization: `Bearer ${authenticateToken()}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify(readyData),
        }
      )
        .then((res) => res.json())
        .then((res) => {
          setLoading(false);

          if (res.statusCode === 200) {
            responseNotification("Category Changed Successfully", "success");
            fetchProducts();
            setVisible(!visible);
            form.resetFields();
          } else if (res.status === 500) {
            responseNotification("Internal server error", "error");
          } else {
            responseNotification(res.message || "something wrong", "warning");
          }
        })
        .catch((err) => {
          setLoading(false);
          responseNotification(`${"Internal server error"} ${err}`, "error");
          console.error("err", err);
        });
    }
  };

  const onChange = (e) => {
    setSelectedProductBarcode((prevVal: any) => {
      const newVal = e;
      let newArr = Array.from(prevVal);
      const found = prevVal.find((item) => item === newVal);
      if (!found) {
        newArr.push(newVal);
      } else {
        newArr = newArr.filter((item) => item !== newVal);
      }
      return newArr;
    });

    setIndeterminate(
      !!checkedList.length &&
        checkedList.length <= selectedProductBarcode.length
    );
    setCheckAll(checkedList.length === selectedProductBarcode.length);
  };

  const onCheckAllChange = (e) => {
    setSelectedProductBarcode(e.target.checked ? checkedList : []);
    setIndeterminate(false);
    setCheckAll(e.target.checked);
  };

  const fetchRef = useRef(null);
  const handleSearch = React.useMemo(() => {
    const loadOptions = (value: string, field: string) => {
      fetchRef.current += 1;
      const fetchId = fetchRef.current;

      if (fetchId !== fetchRef.current) {
        return;
      }
      if (type) {
        if (value) {
          if (field === "product") getProductOptions(value);
          else if (field === "productByBarcode")
            getProductByBarcodeOptions(value);
          else if (field === "parentCategory") getParentCatOptions(value);
          else if (field === "category") getCategoriesOptions(value);
          else if (field === "brand") getBrandsOptions(value);
          else if (field === "merchant") getMerchantsOptions(value);
          else if (field === "shop") getShopsOptions(value);
          else if (field === "supplier") getSupplierOptions(value);
        }
      } else {
        responseNotification("Select a type before search", "warning");
      }
    };

    return debounce(loadOptions, 500);
  }, [
    getBrandsOptions,
    getParentCatOptions,
    getCategoriesOptions,
    getProductOptions,
    getProductByBarcodeOptions,
    getMerchantsOptions,
    getShopsOptions,
    getSupplierOptions,
    type,
  ]);

  useEffect(() => {
    setShopId("");
    setShopsOptions({ list: [], loading: false });
    setBrandId("");
    setIsDeleted("");
    setBrandsOptions({ list: [], loading: false });
    // setParentCatId(queryParams.get("parentCatId"));
    // setCategoryId(queryParams.get("categoryId"));
    setParentCatOptions({ list: [], loading: false });
    setCategoriesOptions({ list: [], loading: false });
    // setBarCode(queryParams.get("barCode"));
    // setKey(queryParams.get("key"));
    form.resetFields([
      "barcode_search",
      "product_search",
      "parentCat_search",
      "category_search",
      "brand_search",
      "shop_search",
    ]);
  }, [form, type]);

  useEffect(() => {
    fetchProducts();
  }, [fetchProducts]);

  useEffect(() => {
    if (visible) {
      getMerchantsOptions();
      getShopsOptions();
    }
  }, [getMerchantsOptions, getShopsOptions, visible]);

  useEffect(() => {
    if (merchantId) {
      getShopsOptions();
    }
  }, [getShopsOptions, merchantId]);

  useEffect(() => {
    if (shopId) {
      getSupplierOptions();
    }
  }, [getShopsOptions, shopId]);

  useEffect(() => {
    if (drawerParentCatId) {
      setTargetCategoryId(undefined);
      form.resetFields(["targetCategoryId"]);
    }
  }, [drawerParentCatId, form, type]);

  useEffect(() => {
    if (type) {
      getParentCatOptions();
      getBrandsOptions();
      getMerchantsOptions();
    }
  }, [getBrandsOptions, getMerchantsOptions, getParentCatOptions, type]);

  useEffect(() => {
    if (parentCategoryId || drawerParentCatId) {
      getCategoriesOptions();
    }
  }, [getCategoriesOptions, parentCategoryId, drawerParentCatId]);

  const createProps = {
    total: productData?.item?.totalElements,
    categoriesOptions,
    parentCatOptions,
    shopsOptions,
    brandsOptions,
    refetch: fetchProducts,
    setType,
    handleSearch,
    type,
  } as unknown as ProductCreateProps;

  const reseAllFieldData = () => {
    // if (queryParams.has("key")) queryParams.delete("key");
    // setKey("");

    // if (queryParams.has("barCode")) queryParams.delete("barCode");
    // setBarCode("");
    // if (queryParams.has("type")) queryParams.delete("type");
    // setType("");

    // if (queryParams.has("categoryId")) queryParams.delete("categoryId");
    // if (queryParams.has("page")) queryParams.delete("page");
    // setCategoryId("");
    // setBrandId("");
    // form.resetFields();

    // history.replace({
    //   search: queryParams.toString(),
    // });
    // window.location.reload();
    history.replace(router.pathname);
    window.location.reload();
  };

  useEffect(() => {
    if (activeClone) {
      form.resetFields();
    }
  }, [activeClone]);

  const showDrawer = () => {
    setVisible(true);
  };

  const onClose = () => {
    form.resetFields();
    setVisible(false);
    setActiveClone(undefined);
    setChangeCat(undefined);
  };

  function checkLocalStorageAndSetParams() {
    var retrievedObject = JSON.parse(
      localStorage.getItem("rememberGlobalProductList")
    );
    console.log("rememberGlobalProductList: ", retrievedObject);
    if (retrievedObject.type) setType(retrievedObject.type);
    if (retrievedObject.barCode) setBarCode(retrievedObject.barCode);
    if (retrievedObject.parentCategoryId)
      setParentCategoryId(retrievedObject.parentCategoryId);
    if (retrievedObject.childCategoryId)
      setChildCategoryId(retrievedObject.childCategoryId);
    if (retrievedObject.key) setKey(retrievedObject.key);
    if (retrievedObject.page) {
      history.push(getUpdatedUrl("page", `${retrievedObject.page}`));
    }
  }
  const saveCurrentStatesInLocalStorage = () => {
    localStorage.setItem(
      "rememberGlobalProductList",
      JSON.stringify({
        type: type,
        barCode: barCode,
        parentCategoryId: parentCategoryId,
        childCategoryId: childCategoryId,
        key: key,
        page: page,
      })
    );
  };

  const goToProductDetail = (value) => {
    saveCurrentStatesInLocalStorage();
    history.push(`/global-products/${value}/details`);
  };

  const goToProductEdit = (value) => {
    saveCurrentStatesInLocalStorage();
    history.push(`/global-products/${value}/edit`);
  };

  function getCategoryName() {
    categoriesOptions?.list?.forEach((category) => {
      if (category?.id === childCategoryId) return category?.title;
    });
    return "";
  }

  function info(alreadyExistsData) {
    Modal.info({
      title: `Successfully added ${alreadyExistsData?.newAdded} item(s) and already exists ${alreadyExistsData?.alreadyExists} item(s)`,
      content: (
        <ul>
          {alreadyExistsData?.list?.map((alreadyExistsProductName, i) => (
            <>
              <small>
                {i + 1}. {alreadyExistsProductName}
              </small>
              <br />
            </>
          ))}
        </ul>
      ),
      width: 600,
      onOk() {},
      okText: "GOT IT",
    });
  }

  return (
    <React.Fragment>
      <div className="product-lists">
        <TopHeading
          {...createProps}
          right={
            <Button
              type="primary"
              onClick={() => {
                showDrawer();
              }}
              disabled={!selectedProductBarcode.length}
              size="large"
              className="mr-3"
            >
              <SwapOutlined /> Action
            </Button>
          }
        />
        <section className="search_area">
          <Form form={form} className="search_form">
            <Form.Item name="type_search" initialValue={type}>
              <Select
                showSearch
                placeholder="Filter by Type"
                onChange={(val) => setType(val as string)}
              >
                {Object.values(jcTypeArray)?.map((type, i) => (
                  <Select.Option value={type} key={i}>
                    {type.replace("_", " ")}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>

            <Form.Item name="barcode_search" initialValue={barCode}>
              <AutoComplete
                onSearch={(e) => handleSearch(e, "productByBarcode")}
                onSelect={(val) => setBarCode(val)}
                options={productBarcodeOptions?.list}
                defaultActiveFirstOption={false}
                notFoundContent={
                  productBarcodeOptions?.loading ? <Spin size="small" /> : null
                }
              >
                <Input.Search
                  size="large"
                  placeholder="Search by BarCode"
                  onSearch={(val) => {
                    setBarCode(val as string);
                    // setBarCodeAndCheckValidityForQueryParam(val);
                  }}
                  enterButton
                  loading={productBarcodeOptions.loading}
                  pattern={`[0-9]`}
                  maxLength={11}
                />
              </AutoComplete>
            </Form.Item>

            <Form.Item name="product_search" initialValue={key}>
              <AutoComplete
                onSearch={(e) => handleSearch(e, "product")}
                onSelect={(val) => setKey(val.toString())}
                options={productOptions?.list}
                defaultActiveFirstOption={false}
                notFoundContent={
                  productOptions?.loading ? <Spin size="small" /> : null
                }
              >
                <Input.Search
                  size="large"
                  placeholder="Search by Name"
                  onSearch={(val) => {
                    setKey(val);
                    // setKeyAndCheckValidityForQueryParam(val);
                  }}
                  enterButton
                  loading={productOptions.loading}
                  pattern={`[0-9]`}
                  maxLength={11}
                />
              </AutoComplete>
            </Form.Item>

            <Form.Item name="parentCat_search" initialValue={parentCategoryId}>
              <Select
                allowClear
                showSearch
                placeholder="Parent Category"
                optionFilterProp="children"
                onChange={(val) => setParentCategoryId(val)}
                onSearch={(e) => {
                  handleSearch(e, "parentCategory");
                  form.resetFields(["category_search"]);
                }}
                filterOption={(input, option) =>
                  option.children
                    .toString()
                    .toLowerCase()
                    .indexOf(input.toLowerCase()) >= 0
                }
              >
                {parentCatOptions?.list?.map((category) => (
                  <Option value={category?.value} key={category?.value}>
                    {category?.label}
                  </Option>
                ))}
              </Select>
            </Form.Item>

            <Form.Item name="category_search" initialValue={childCategoryId}>
              <Select
                allowClear
                showSearch
                placeholder="Sub Category"
                defaultValue={getCategoryName}
                optionFilterProp="children"
                onChange={(val) => setChildCategoryId(val)}
                onSearch={(e) => handleSearch(e, "category")}
                filterOption={(input, option) =>
                  option.children
                    .toString()
                    .toLowerCase()
                    .indexOf(input.toLowerCase()) >= 0
                }
                disabled={!categoriesOptions?.list?.length}
              >
                {categoriesOptions?.list?.map((category) => (
                  <Option value={category?.value} key={category?.value}>
                    {category?.label}
                  </Option>
                ))}
              </Select>
            </Form.Item>
          </Form>
          <div className="search_btn">
            <Button
              type="primary"
              size="large"
              danger
              onClick={reseAllFieldData}
            >
              Reset
            </Button>
          </div>
        </section>

        <div className="product-list-item-area white-bg section-padding-bottom">
          <div className="container-fluid">
            <div className="row">
              <div className="col-lg-12">
                <div className="product-list-items-inner-content">
                  <div className="single-product-wrapper">
                    <div className="single-product-heading major">
                      <Checkbox
                        indeterminate={indeterminate}
                        onChange={onCheckAllChange}
                        checked={
                          checkAll ||
                          selectedProductBarcode?.length === checkedList?.length
                        }
                        className="mr-3"
                        disabled={!productData.item?.products?.length}
                      >
                        Check all
                      </Checkbox>
                    </div>
                    <div className="single-product-heading major">
                      <span>Stock & Price</span>
                    </div>
                    <div className="single-product-heading">
                      <span>Action</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="row">
              {productData.loading ? (
                <Loading />
              ) : (
                <div className="col-lg-12 product-table">
                  <div className="product-table-area">
                    {productData.item?.products?.length ? (
                      productData?.item?.products?.map(
                        (product: any, index: number) => (
                          <React.Fragment key={index}>
                            <div
                              onClick={(e) => {
                                e.preventDefault();
                                goToProductDetail(product?.slug);
                              }}
                              // to={`/global-products/${product?.barCode}/details`}
                            >
                              <div className="single-product-wrapper">
                                <div className="single-product major">
                                  <Checkbox
                                    onClick={(e) => {
                                      e.preventDefault();
                                      e.stopPropagation();
                                      onChange(product?.barCode);
                                    }}
                                    checked={selectedProductBarcode?.find(
                                      (item) => product?.barCode === item
                                    )}
                                    className="mr-3"
                                    value={product?.barCode}
                                  />
                                  <Avatar
                                    shape="square"
                                    size={50}
                                    src={getImgUrl(product?.productImage)}
                                    className="mr-3"
                                  />
                                  <span className="name">{product?.name}</span>
                                </div>
                                <div className="single-product major">
                                  <div className="d-flex_">
                                    {product?.variations?.length
                                      ? product?.variations?.map(
                                          (variant, index) => (
                                            <React.Fragment key={index}>
                                              <div className="d-flex justify-content-start mb-1">
                                                {variant?.barCode ? (
                                                  <Tag className="d-flex align-items-center">
                                                    <BarcodeOutlined className="mr-1" />{" "}
                                                    {variant?.barCode}
                                                  </Tag>
                                                ) : product?.barCode ? (
                                                  <Tag className="d-flex align-items-center">
                                                    <BarcodeOutlined className="mr-1" />{" "}
                                                    {product?.barCode}
                                                  </Tag>
                                                ) : undefined}

                                                <Tag>
                                                  MRP{" "}
                                                  {variant?.price?.currencyCode}
                                                  {variant?.price
                                                    ?.discountedPrice ||
                                                    variant?.price?.mrp}
                                                  {variant?.price
                                                    ?.discountedPrice &&
                                                    variant?.price
                                                      ?.discountedPrice !==
                                                      variant?.price?.mrp && (
                                                      <span className="text-danger">
                                                        {" "}
                                                        <del>
                                                          {variant?.price
                                                            ?.currencyCode ||
                                                            "Tk"}
                                                          {variant?.price?.mrp}
                                                        </del>
                                                      </span>
                                                    )}
                                                </Tag>
                                                <Tag>
                                                  TP {variant?.price?.tp}{" "}
                                                  {variant?.price?.currencyCode}
                                                </Tag>
                                              </div>
                                            </React.Fragment>
                                          )
                                        )
                                      : undefined}
                                  </div>
                                </div>

                                {/* <div className="single-product">
                                  <Switch
                                    checkedChildren={<CheckOutlined />}
                                    unCheckedChildren={<CloseOutlined />}
                                    defaultChecked={!product?.deleted}
                                    onChange={(val, e) => {
                                      e.preventDefault();
                                      e.stopPropagation();
                                      onDelete(product?.barCode, val);
                                    }}
                                    className="ml-2"
                                  />
                                </div> */}

                                <div className="single-product">
                                  <Button
                                    onClick={(e) => {
                                      e.preventDefault();
                                      e.stopPropagation();
                                      // history.push(
                                      //   `/global-products/${product?.barCode}/edit`
                                      // );
                                      goToProductEdit(product?.slug);
                                    }}
                                  >
                                    <EditOutlined />
                                  </Button>
                                </div>
                              </div>
                            </div>
                          </React.Fragment>
                        )
                      )
                    ) : (
                      <Empty data="Products" />
                    )}
                  </div>
                </div>
              )}
            </div>
            <PaginationTwo
              {...productData.item}
              limit={limit}
              page={productData?.item?.currentPageNumber || 0}
            />
          </div>
        </div>
      </div>

      <Drawer
        title={
          changeCat
            ? "Change Category"
            : activeClone
            ? "Clone Product"
            : "Take Action"
        }
        placement="right"
        onClose={onClose}
        visible={visible}
        width={400}
      >
        <Radio.Group defaultValue="" buttonStyle="solid" className="mb-5">
          <Radio.Button
            value="clone_product"
            onChange={() => {
              setActiveClone(true);
              setChangeCat(undefined);
              // setChangeStatus(undefined);
              form.resetFields();
            }}
          >
            Clone Product
          </Radio.Button>
          <Radio.Button
            value="change_category"
            onChange={() => {
              setChangeCat(true);
              setActiveClone(undefined);
              form.resetFields();
            }}
          >
            Change Category
          </Radio.Button>
        </Radio.Group>
        <div className="">
          <Form
            name="control-hooks"
            labelCol={{ span: 24 }}
            wrapperCol={{ span: 24 }}
            className="ant-form ant-form-vertical"
            onFinish={onSubmit}
            form={form} // like ref
            layout="vertical"
            autoComplete="off"
          >
            <Form.Item label="Products Barcodes">
              <Input.TextArea
                value={selectedProductBarcode}
                disabled
                rows={8}
              />
            </Form.Item>
            {activeClone && (
              <>
                <Alert
                  message="Where do you want to CLONE the selected items?"
                  type="warning"
                  banner
                  closable
                  className="mb-4"
                />
                <Form.Item label="Select Merchant">
                  <Select
                    allowClear
                    showSearch
                    placeholder="Select Merchant"
                    optionFilterProp="children"
                    onChange={(val) => setMerchantId(val)}
                    onSearch={(e) => handleSearch(e, "merchant")}
                    filterOption={(input, option) =>
                      option.children
                        .toString()
                        .toLowerCase()
                        .indexOf(input.toLowerCase()) >= 0
                    }
                  >
                    {merchantOptions.list.map((merchant) => (
                      <Option value={merchant.value} key={merchant.value}>
                        {merchant.label}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>

                <Form.Item label="Select Shop" name="shopId">
                  <Select
                    allowClear
                    showSearch
                    placeholder="Select Shop to Clone Product"
                    optionFilterProp="children"
                    onChange={(val) => {
                      setShopId(val);
                    }}
                    onSearch={(e) => handleSearch(e, "shop")}
                    filterOption={(input, option) =>
                      option.children
                        .toString()
                        .toLowerCase()
                        .indexOf(input.toLowerCase()) >= 0
                    }
                  >
                    {shopsOptions.list.map((shop) => (
                      <Option value={shop.value} key={shop.value}>
                        {shop.label}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>

                <Form.Item label="Select Supplier" name="supplierId">
                  <Select
                    allowClear
                    showSearch
                    autoClearSearchValue
                    onSearch={(e) => handleSearch(e, "supplier")}
                    onChange={(val) => {
                      setSupplierId(val);
                    }}
                    options={suppliersOptions?.list}
                    maxTagTextLength={20}
                    disabled={!shopId}
                    placeholder="Select Supplier if Needed"
                  ></Select>
                </Form.Item>
              </>
            )}

            {changeCat && (
              <>
                <Alert
                  message="Are you sure to Change Category? After change category the selected items, it will change in Hub or Shop also."
                  type="warning"
                  banner
                  closable
                  className="mb-4"
                />

                <Form.Item
                  label="Select Parent Category"
                  name="drawerParentCatId"
                >
                  <Select
                    allowClear
                    showSearch
                    placeholder="Select Parent Category"
                    optionFilterProp="children"
                    onChange={(val) => setDrawerParentCatId(val)}
                    onSearch={(e) => handleSearch(e, "parentCategory")}
                    filterOption={(input, option) =>
                      option.children
                        .toString()
                        .toLowerCase()
                        .indexOf(input.toLowerCase()) >= 0
                    }
                  >
                    {parentCatOptions?.list?.map((category) => (
                      <Option value={category?.value} key={category?.value}>
                        {category?.label}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>

                <Form.Item
                  label="Select Category"
                  name="targetCategoryId"
                  rules={[
                    {
                      required: true,
                      message: "Category is Required!",
                    },
                  ]}
                >
                  <Select
                    allowClear
                    showSearch
                    placeholder="Select Category"
                    optionFilterProp="children"
                    onChange={(val) => setTargetCategoryId(val)}
                    onSearch={(e) => handleSearch(e, "category")}
                    filterOption={(input, option) =>
                      option.children
                        .toString()
                        .toLowerCase()
                        .indexOf(input.toLowerCase()) >= 0
                    }
                    disabled={!categoriesOptions?.list?.length}
                  >
                    {categoriesOptions?.list?.map((category) => (
                      <Option value={category?.value} key={category?.value}>
                        {category?.label}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </>
            )}

            <Button
              type="primary"
              danger
              title="Clone Selected Items"
              disabled={(!shopId && !targetCategoryId) || loading}
              size="large"
              htmlType="submit"
              className="mr-3"
              loading={(loading ? "loading" : undefined) as any}
            >
              {changeCat ? (
                <>
                  <CopyOutlined /> Change Category
                </>
              ) : (
                <>
                  <CopyOutlined /> Clone Items
                </>
              )}
            </Button>
          </Form>
        </div>
      </Drawer>
    </React.Fragment>
  );
};

export default GlobalProductList;
